import React from "react";
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Legend, PointElement, LineElement, Tooltip } from "chart.js";
import { Bar, Line } from "react-chartjs-2";


const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const emptyMonthsMap = [...Array(12)]
  .map((_i, idx) => idx)
  .reduce((acc, idx) => {
    acc[idx] = 0;
    return acc;
  }, {} as Record<string, number>);

const getEmptyMonthsMap = () => ({ ...emptyMonthsMap });


const backgroundColors = [
  "rgba(255, 99, 132, 0.2)", // Red
  "rgba(54, 162, 235, 0.2)", // Blue
  "rgba(255, 206, 86, 0.2)", // Yellow
  "rgba(75, 192, 192, 0.2)", // Green
];

const borderColors = [
  "rgba(255, 99, 132, 1)", // Red
  "rgba(54, 162, 235, 1)", // Blue
  "rgba(255, 206, 86, 1)", // Yellow
  "rgba(75, 192, 192, 1)", // Green
];

const processData = (data: { month: string; count: number; }[]) => {
  const yearsData = new Map<number, Record<string, number>>();

  data.forEach((item) => {
    const itemDate = new Date(item.month);
    const year = itemDate.getFullYear();
    const month = itemDate.getMonth();

    // Initialize the year if not already done
    if (!yearsData.has(year)) {
      yearsData.set(year, getEmptyMonthsMap());
    }

    // Update the count for the month of that year
    const yearData = yearsData.get(year);
    if (yearData) {
      yearData[month] = item.count;
    }
  });

  // Now, yearsData contains the data for each year.
  // You can use it to create datasets for your chart.
  // Example: Create datasets for the last two years
  const toSort = [] as [number, Record<string, number>][];
  yearsData.forEach((yearData, year) => {
    toSort.push([year, yearData]);
  });
  const sorted = toSort.sort((a, b) => b[0] - a[0]);

  const datasets = sorted.map(([year, yearData], idx) => ({
    label: `Year ${year}`,
    data: yearData ? Object.values(yearData) : [],
    backgroundColor: backgroundColors[idx],
    borderColor: borderColors[idx],
    borderWidth: 1,
  }));

  return {
    labels: months,
    datasets,
  };
};

const options = {
  plugins: {
    legend: {
      position: "top" as const,
    },
  },
};

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Legend,
  LineElement,
  PointElement,
  Tooltip,
);

const ApplicationComparisonChart: React.FC<{data: { month: string; count: number; }[]}> =
({ data }) => {
  const chartData = processData(data);

  return (<>
    <Bar data={chartData} />
    <Line data={chartData} options={options} />
  </>
  );
};

export default ApplicationComparisonChart;
